// [ambiente 2026-07-01] Tarja de ambiente (Produção/Homologação) OCULTA por pedido do
// usuário. O status do ambiente fiscal continua acessível em Configurações → Empresa.
// Pra reativar a tarja, restaure a versão anterior deste arquivo (git).
export default function AmbienteBanner() {
  return null
}
